import { StringKey } from '../../lang/index';

export enum ProfileTab {
  NOTIFICATIONS = 'notifications',
  PERSONAL_INFO = 'personal-info',
}

export const profileTabTitle: Record<ProfileTab, StringKey> = {
  [ProfileTab.PERSONAL_INFO]: 'PERSONAL_INFO',
  [ProfileTab.NOTIFICATIONS]: 'NOTIFICATIONS',
};

export const profileTabMap = Object.values(ProfileTab);

export const profileTabTitleMap = Object.entries(profileTabTitle);
